var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('database-picker',{attrs:{"return-id":_vm.returnId,"required":_vm.required,"rules":_vm.rules,"color":_vm.color,"label":"Teminat Türü","action":"/api/v1/teminat-turu","cache-active":""},on:{"input":_vm.input},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }